import axios from 'axios';
import { api_url, mg_token_name } from '../config/Params.constant';
import storage from './Storage';

class ArrivageFBService {
  create(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.post(`${api_url}/arrivage-fbs`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  update(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.put(`${api_url}/arrivage-fbs/${data?.idArrivageFB}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  remove(id) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.delete(`${api_url}/arrivage-fbs/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  view(id) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/arrivage-fbs/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  viewAll(query) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(
      `${api_url}/arrivage-fbs${query?.page ? `?page=${query?.page}&limit=${query?.limit ?? 20}` : ''}${query?.search ? `&search=${query?.search}` : ''}${query?.status ? `&status=${query?.status}` : ''}${query?.fournisseur ? `&fournisseur=${query?.fournisseur}` : ''}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          [mg_token_name]: `${mgToken}`,
        },
      },
    );
  }
}

export default new ArrivageFBService();
